import {useTranslation} from "react-i18next";
import React from "react";
//import {CleanUrl} from "../../../utils/cleanUrl";

const RelatedPromotions = ({promotionSettings}) => {

	//console.log('insinde related pormotion', promotionSettings)

	const {headline, image, text, url, cta_label, destination_event_campaign} = promotionSettings.related_promotions[0]; //because we have just 1 now

	const {t} = useTranslation();

	//const imagePath = CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}`);

	const handleClick = (e) => {
		e.preventDefault(); // prevent default link behavior for a moment

		const dataLayerEvent = {
			event: 'thank_you_teaser',
			page: 'Thank you page',
			user_id: window.drupalSettings?.pepsico_joy_eu_warehouse_reporting.user_id,
			event_id: 1.15,
			event_campaign: promotionSettings?.promotion_page?.promotion_title,
			text: headline,
			link_url: url,
			destination_event_campaign,
		};

		//console.log('[RelatedPromotions] Pushing to dataLayer:', dataLayerEvent);

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(dataLayerEvent);

		// Navigate after a small delay to ensure dataLayer is pushed
		setTimeout(() => {
			window.location.href = url;
		}, 150);
	};

	return (
		<div className="participation-app-brand-banner" role="region" aria-label={t("Related Promotion")}>
			<div className="participation-app-brand-banner-content">
				<div className="participation-app-brand-banner-content__image">
					<a href={url} onClick={handleClick} aria-label={headline}>
						<picture>
							<img src={image} alt={headline || t("Related promotion image")} />
						</picture>
					</a>
				</div>
				<div className="participation-app-brand-banner-content__text">
					<h4>{headline}</h4>
					<p dangerouslySetInnerHTML={{ __html: text }} />
					<a className="btn btn-primary" href={url} aria-label={cta_label} onClick={handleClick}>{cta_label}</a>
				</div>
			</div>
		</div>
	);

}

export default RelatedPromotions;
